module.exports = __webpack_public_path__ + "media/images/howtoplay1-ffad08502024695dcaee7b10a2ccf4c1.png";